import { AxiosInstance } from 'axios'
import { Dispatch } from 'redux'
import { IMedarbetare } from '../features/medarbetare'
import { ISetMedarbetareAction, setMedarbetareAction } from '../features/medarbetare/store/actions'

// Löpnummer för listans hämtningar – bara svaret på den senaste frågan hamnar i listan (#101).
// Två frågor kan vara ute samtidigt (byte av period, omhämtning efter hantering) och svaren kan
// komma i omvänd ordning. Utan numret visades det svar som kom sist, ibland för en annan period
// än den som står i periodväljaren. Numret ligger här och inte på sidan, eftersom alla som hämtar
// listan skriver till samma ställe i Redux.
let senasteFråga = 0

export const setMedarbetare = async (api: AxiosInstance, dispatch: Dispatch<ISetMedarbetareAction>, date?: { from: string; to: string }) => {
  let from
  let to

  if (date) {
    from = date.from
    to = date.to
  } else {
    from = '2020-01-01'
    to = '2021-12-31'
  }

  const nr = ++senasteFråga
  try {
    const medarbetare = await api.get<IMedarbetare[]>(`/v1/medarbetare/${localStorage.getItem('tenant_id')}/all?from=${from}&to=${to}`, {
      headers: {
        authorization: 'Bearer ' + localStorage.getItem('hydra_access_token'),
      },
    })

    if (nr !== senasteFråga) return

    if (medarbetare.data === []) {
      setMedarbetareAction('SET_MEDARBETARE', [], dispatch)
      return
    }

    const formattedData = medarbetare.data.map((item: IMedarbetare) => {
      return {
        key: item.id,
        flagga: item.flagga,
        flaggnamn: item.flaggnamn,
        nivå: item.nivå,
        namn: item.namn,
        medarbetare_id: item.medarbetare_id,
        från: item.från,
        till: item.till,
        created: item.created,
        utförare: item.utförare,
        hantering: item.hantering,
      }
    })

    return setMedarbetareAction('SET_MEDARBETARE', formattedData, dispatch)
  } catch (err) {
    console.log(err)
  }
}

export type IPerson = { id: number; namn: string }

const auth = () => ({ headers: { authorization: 'Bearer ' + localStorage.getItem('hydra_access_token') } })

// Personalsidan gäller en person och adresseras på Pejlens id (#99). Namnet hämtas till rubriken.
export const hämtaMedarbetare = async (api: AxiosInstance, id: number): Promise<IPerson | undefined> => {
  try {
    return (await api.get<IPerson>(`/v1/medarbetare/${localStorage.getItem('tenant_id')}/person/${id}`, auth())).data
  } catch (err) {
    console.log(err)
    return undefined
  }
}

// Gamla länkar med namn: personerna med namnet, så att sidan kan skicka vidare eller låta användaren välja (#99)
export const sökMedarbetarePåNamn = async (api: AxiosInstance, namn: string): Promise<IPerson[]> => {
  try {
    return (await api.get<IPerson[]>(`/v1/medarbetare/${localStorage.getItem('tenant_id')}/name/${encodeURIComponent(namn)}`, auth())).data
  } catch (err) {
    console.log(err)
    return []
  }
}
